
const mutations = {
  setRates(state, payload) {
    state.currencies = {
      ...state.currencies,
      ...payload
    }
  },
  setErrorsStatus(state, payload) {
    state.hasErrors = payload
  },
}

export default mutations